// GeneralStyles.js

import styled from "styled-components";

// Existing utility functions
export const lighten = (color, amount) => adjustColor(color, amount);
export const darken = (color, amount) => adjustColor(color, -amount);

const adjustColor = (color, amount) => {
  // Ensure color is a valid hex code
  if (color[0] === '#') {
    color = color.slice(1);
  }

  const num = parseInt(color, 16);

  let r = (num >> 16) + amount;
  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  let g = ((num >> 8) & 0x00FF) + amount;
  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  let b = (num & 0x0000FF) + amount;
  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  return `#${(r.toString(16).padStart(2, '0'))}${(g.toString(16).padStart(2, '0'))}${(b.toString(16).padStart(2, '0'))}`;
};

export const tint = (color, amount) => {
  let usePound = false;

  if (color[0] === "#") {
    color = color.slice(1);
    usePound = true;
  }

  const num = parseInt(color, 16);

  let r = (num >> 16);
  let g = (num >> 8) & 0x00FF;
  let b = num & 0x0000FF;

  r = Math.round(r + (255 - r) * amount / 100);
  g = Math.round(g + (255 - g) * amount / 100);
  b = Math.round(b + (255 - b) * amount / 100);

  return (usePound ? "#" : "") + (r.toString(16).padStart(2, '0')) + (g.toString(16).padStart(2, '0')) + (b.toString(16).padStart(2, '0'));
};

const grayscale = (color, amount) => {
  let usePound = false;

  if (color[0] === "#") {
    color = color.slice(1);
    usePound = true;
  }

  const num = parseInt(color, 16);

  let r = (num >> 16);
  let g = ((num >> 8) & 0x00FF);
  let b = (num & 0x0000FF);

  const gray = Math.round((r + g + b) * amount / 100);

  return (usePound ? "#" : "") + (gray.toString(16).padStart(2, '0')) + (gray.toString(16).padStart(2, '0')) + (gray.toString(16).padStart(2, '0'));
};

// Existing styled components
export const QuizScreen = styled.div`
  // padding: 20px;
  position:relative;
  @media only screen and (max-width: 600px) {
    padding: 0vh 0vw;
  }
   
  ${(props) => props.bgVisible && props.bgColor && `
    background-color: ${tint(props.bgColor, 90)};
    border: 1px solid #ccc;
    border-radius: 10px;
  `}
  margin-bottom: 20px;
`;

export const QuizButton = styled.button`
  padding: 20px 30px;
  font-size: 1.3em;
  border: none;
  font-weight:bold;
  border-radius: 10px;
  box-shadow: 0 4px 6px -1px #001d2910, 0 2px 4px -2px #001d2910;
  cursor: pointer;
  background: ${(props) => props.bgColor}; // Wissel bgColor en Color als design 'negative' is
  color: ${(props) => props.txtColor}; // Wissel color en bgColor als design 'negative' is
  display: block;
  margin: 20px auto;
  &:hover {
    background: ${(props) => darken(props.bgColor,30)}; // Wissel bgColor en Color als design 'negative' is
    color: ${(props) => darken(props.txtColor, 10) }; // Wissel color en bgColor als design 'negative' is
  }
  &:disabled {
    background: ${(props) => lighten(props.bgColor, 90)};
    color: ${(props) => lighten(props.txtColor, 70)};
    cursor: not-allowed;
  }
`;

export const QuizTitle = styled.h3`
  font-size: 2em;
  color:  #031037;
  font-family: 'Arial', 'Helvetica Neue', 'Helvetica', 'Nimbus Sans L', 'Liberation Sans', 'Arimo', 'DejaVu Sans', 'Sans-Serif';
  text-align:  ${(props) => (props.textAlign ? props.textAlign : "center")};
`;

export const QuizDescription = styled.p`
  font-size: 1.2em;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
  
`;

export const QuizDescriptionDiv = styled.div`
  font-size: 1.2em;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
  h1, h2, h3, h4, h5, h6 {
    background-color: ${(props) => props.bgColor || "initial"};
    color: ${(props) => props.color || "initial"};
    display:table;
    margin:10px auto;
    
  }
  h1 {
    border-radius: 14px;
    padding: 8px;
    padding-inline:  calc( 8px + calc((1lh -  1ex) / 2));
  }
    h2 {
    border-radius: 11px;
    padding: 7.5px;
    padding-inline:  calc( 8px + calc((1lh -  1ex) / 2));
  }
    h3 {
    border-radius: 10px;
    padding: 7px;
    padding-inline:  calc( 8px + calc((1lh -  1ex) / 2));
  }
    h4 {
    border-radius: 9px;
    padding: 6.5px;
    padding-inline:  calc( 8px + calc((1lh -  1ex) / 2));
  }
    h5 {
    border-radius: 8px;
    padding: 6px;
    padding-inline:  calc( 8px + calc((1lh -  1ex) / 2));
  }
    h6 {
    border-radius: 6px;
    padding: 5.5px;
    padding-inline:  calc( 8px + calc((1lh -  1ex) / 2));
  }
  p {
    margin:auto;
    width: 100%;
    max-width: 800px;
    white-space: pre-line;
  }
  img {
    display: block;
    width:100%;
  }
`;

export const QuizMessage = styled.div`
  font-size: max(1rem, 20px);/*1.2em;*/
  color:  ${(props) => (props.color ? props.color : "#031037")};
  text-align: center;
  margin-top: 20px;

  p {
    white-space: pre-line;
  }
`;

// New styled component for rendering media
export const QuizMessageMedia = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    max-width: 80vw;
    height: auto;
    margin-bottom: 10px;
  }

  audio {
    display: none; /* Hide audio elements */
    /* Alternatively, set width to 0 to hide visually but keep it in DOM */
    width: 0;
    height: 0;
  }

  video {
    max-width: 80vw;
    height: auto;
    margin-bottom: 10px;
  }

  iframe {
    max-width: 80vw;
    height: auto;
    margin-bottom: 10px;
  }
`;

export const QuizForm = styled.form`
position:relative;
`;
// GeneralStyles.js
export const QuizFormHorizontal = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 15px;
  flex-wrap: nowrap;

  &.wrap {
    flex-wrap: wrap;
    align-items: flex-start;

    > div {
      width: calc((100% / 4) - (15px / 1));
      @media (max-width: ${(props) => 1300 * props.scaleFactor}px) {
        width: calc((100% / 3) - (15px / 1));
      }

      @media (max-width: ${(props) => 1100 * props.scaleFactor}px) {
        width: calc((100% / 2) - (15px / 2));
      }
    }
  }

  @media (max-width: ${(props) => 700 * props.scaleFactor}px) {
    flex-direction: column;
    width: 100%;

    > div {
      width: 100%;
    }

    &.wrap {
      > div {
        width: 100%;
      }
    }
  }
`;


export const QuizFormVertical = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const QuizInput = styled.input`
  width: 100%;
  max-width: 300px;
  padding: 10px;
  font-size: 15px;
  margin-bottom: 10px;
  border: 2px solid #ddd;
  box-shadow: 0 4px 6px -1px #001d2910, 0 2px 4px -2px #001d2910;
  border-radius: 10px;
`;

export const QuizTextArea = styled.textarea`
  width: 100%;
  line-height:1.5;
  margin-bottom: 10px;
  resize: vertical;
  font-size: 1.2rem;
  border: 2px solid #ddd;
  box-shadow: 0 4px 6px -1px #001d2910, 0 2px 4px -2px #001d2910;
  border-radius: 10px;
  field-sizing: content;
  padding: 10px;
  padding-inline: calc(10px + calc((1lh - 1ex) / 2));
  min-height: calc(1.6lh + 2 * 10px);
  max-height: calc(3lh + 2 * 10px);

  ${(props) => props.borderColor && `
    &:focus {
      border-color: ${props.borderColor};
      outline: none; /* Optional: Remove default focus outline */
    }
  `}
`;
export const QuizTextInputField = styled.input`
  width: 100%;
  margin-bottom: 10px;
  resize: vertical;
  font-size: 1rem;
  border: 2px solid #ddd;
  box-shadow: 0 4px 6px -1px #001d2910, 0 2px 4px -2px #001d2910;
  border-radius: 10px;
  field-sizing: content;
  padding: 20px 10px;
  padding-inline: calc(10px + calc((1lh - 1ex) / 2));
  ${(props) => props.borderColor && `
    &:focus {
      border-color: ${props.borderColor};
      outline: none; /* Optional: Remove default focus outline */
    }
  `}
`;
